import React from 'react';
import {Qualification} from '../../../Components/Charts/QualificationHistoryChart';
import {useGetHistoryQlfcQuery} from '../../../redux/myDynamicApi';
import Loader from '../../../assets/Animations/PreLoaderComponent/Loader';
import {useTranslation} from 'react-i18next';
import s from './HistoryQlfc.module.css';

const HistoryQlfc: React.FC = () => {
	const {t} = useTranslation();
	const {data, isLoading} = useGetHistoryQlfcQuery();
	if (isLoading) return <Loader />;
	if (data && data.qlfc) {
		const sorted = [...data.qlfc].sort(
			(a, b) =>
				new Date(b.start_date).getTime() - new Date(a.start_date).getTime(),
		);
		return (
			<div className="history__column">
				<div className="history__title name">{t('Історія кваліфікацій')}</div>
				{sorted.map((q: Qualification, index: number) => (
					<div className={`history__item ${s.historyItem}`} key={q.end_date + index}>
						<div className={`history__date ${s.dateColumn}`}>
							{t('з {{from}} до {{to}}', {
								from: q.start_date,
								to: q.end_date,
							})}
						</div>
						<div className={`history__label ${s.qualificationColumn}`}>
							<span className={s.qualificationCode}>{q.qualification}</span> {q.name}
						</div>
					</div>
				))}
			</div>
		);
	} else return null;
};

export default HistoryQlfc;

